<template>
    <div class="group">
        <slider animation="fade" :control-btn="false">
           <slider-item><img src="@/assets/images/banner.png"></slider-item>
        </slider>
        <div class="introduceBox">
            <div class="company introduce">
                <div class="title">
                    <div class="label">公司简介</div>
                    <div class="labelE">COMPANY</div>
                    <div class="line"></div>
                </div>
                <div class="des">
                    西安羊羊村落乳业集团有限公司(简称：羊村集团)，总部位于陕西西安，是一家母婴数据电商企业。其凭借多年的母婴行业经验结合西北优势的技术研发团队，开发了董妈咪母婴数据智能平台。
                </div>
            </div>
            <div class="experience introduce">
                <div class="title">
                    <div class="label">发展历史</div>
                    <div class="labelE">EXPERIENCE</div>
                    <div class="line"></div>
                </div>
                <div class="des experienceDes">
                    <div class="timeLine experienceLine">
                        <p>2018年1月，获得母婴行业观察樱桃大赏“2017年度最佳新零售创新大奖!”</p>
                        <img class="desImg" src="@/assets/images/pic_jiangli.png"/>
                    </div>
                    <div class="timeLine Line86">
                        <p>2018年4月，参加第27届京正孕婴童产品博览会</p>
                    </div>
                    <div class="timeLine">
                        <p>2017年7月，参加2017年第17届CBME上海孕婴童展</p>
                    </div>
                    <div class="timeLine">
                        <p>2016年7月，参加2016年第16届CBME中国孕童展</p>
                    </div>
                </div>
            </div>
            <div class="expect introduce">
                <div class="title">
                    <div class="label">企业文化</div>
                    <div class="labelE">EXPECT</div>
                    <div class="line"></div>
                </div>
                <div class="des">
                    愿景：羊村集团致力于改变传统母婴行业现状，整合线上线下销售场景，实现从选品、采购、运营到管理的一站式母婴解决方案
                </div>
            </div>
            <div class="advantage introduce">
                <div class="title">
                    <div class="label">企业优势</div>
                    <div class="labelE">ADVANTAGE</div>
                    <div class="line"></div>
                </div>
                <div class="des">
                    羊村集团拥有多年的母婴数据电商及母婴行业线下零售经验，依托互联网、数据智能等新技术领域，专注为消费者及渠道商提供丰富的多品类产品及服务、数据智能化的运营管理产品。
                </div>
            </div>
            <div class="brand introduce">
                <div class="title">
                    <div class="label">旗下品牌</div>
                    <div class="labelE">BRAND</div>
                    <div class="line"></div>
                </div>
                <div class="products">
                    <div class="proItem">
                        <span class="title">婴幼儿配方奶粉/羊奶粉系列：</span>
                        <div class="contentBox">
                            <div class="content">
                                <div class="itemDes">
                                    <div class="double">
                                    <img src="@/assets/images/pic_yubaozhen.png" />
                                    <div class="itemLabel">
                                        <div class="labelImg"></div>
                                        <div class="label">御宝臻婴幼儿配方羊乳粉</div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="proItem">
                        <span class="title">成人配方羊奶粉系列：</span>
                        <div class="contentBox">
                            <div class="content">
                                <div class="itemDes">
                                    <img src="@/assets/images/pic_tianchun1.png" />
                                    <img src="@/assets/images/pic_tianchun2.png" />
                                </div>
                                <div class="itemLabel">
                                    <div class="labelImg"></div>
                                    <div class="label">添纯儿童配方羊奶粉</div>
                                </div>
                            </div>
                            <div class="content">
                                <div class="itemDes">
                                <img src="@/assets/images/pic_tianbao1.png" />
                                <img src="@/assets/images/pic_tianbao2.png" />
                                </div>
                                <div class="itemLabel">
                                    <div class="labelImg"></div>
                                    <div class="label">添葆中老年配方羊奶粉</div>
                                </div>
                            </div>
                            <div class="content">
                                <div class="itemDes">
                                <img src="@/assets/images/pic_zhenqi1.png" />
                                <img src="@/assets/images/pic_zhenqi2.png" />
                                </div>
                                <div class="itemLabel">
                                    <div class="labelImg"></div>
                                    <div class="label">御宝臻启儿童配方羊奶粉</div>
                                </div>
                            </div>
                            <div class="content">
                                <div class="itemDes">
                                <img src="@/assets/images/pic_yubao1.png" />
                                <img src="@/assets/images/pic_yubao2.png" />
                                </div>
                                <div class="itemLabel">
                                    <div class="labelImg"></div>
                                    <div class="label">御宝儿童高锌配方羊乳粉</div>
                                </div>
                            </div>
                            <div class="content">
                                <div class="itemDes">
                                    <div class="double">
                                    <img src="@/assets/images/pic_yubao3.png" />
                                    <div class="itemLabel">
                                        <div class="labelImg"></div>
                                        <div class="label">御宝金装钙维D配方羊乳粉</div>
                                    </div>
                                    </div>
                                    <div class="double">
                                        <img src="@/assets/images/pic_yubao4.png" />
                                        <div class="itemLabel">
                                            <div class="labelImg"></div>
                                            <div class="label">御宝学生高钙配方羊乳粉</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="content">
                                <div class="itemDes">
                                    <div class="double">
                                    <img src="@/assets/images/pic_yubao5.png" />
                                    <div class="itemLabel">
                                        <div class="labelImg"></div>
                                        <div class="label">御宝学生配方羊乳粉</div>
                                    </div>
                                    </div>
                                    <div class="double">
                                        <img src="@/assets/images/pic_yubao6.png" />
                                        <div class="itemLabel">
                                            <div class="labelImg"></div>
                                            <div class="label">御宝女士果蔬配方羊乳粉</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="content">
                                <div class="itemDes">
                                <img src="@/assets/images/pic_yangru1.png" />
                                <img src="@/assets/images/pic_yangru2.png" />
                                </div>
                                <div class="itemLabel">
                                    <div class="labelImg"></div>
                                    <div class="label">御宝中老年配方羊乳粉</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Slider, SliderItem } from 'vue-easy-slider'
export default {
  name: 'groupIntroduction',
  components: {
    Slider,
    SliderItem
  },
}
</script>

<style lang="less" scoped>
@font-face {
    font-family: fangzheng;
    src: url('/static/FZLTCXHJ_0.OTF')
}
@font-face {
    font-family: yuehei;
    src: url('/static/font/造字工房悦黑（非商用）常规体.otf')
}
@font-face {
    font-family: fzlt;
    src: url('/static/font/FZLTCXHK.otf')
}
.slider {
    width: 100% !important;
    height: 320px !important;
    min-width:1280px;
    img{
      width: 100%;
      height: 100%;
    }
}
.introduceBox{
    width: 1100px;
    margin: 0 auto;
    .introduce{
        margin-top: 120px;
        .title{
            color: #fe4166;
            .label{
                font-family: yuehei;
                font-size: 44px;
                line-height: 44px;
            }
            .labelE{
                line-height: 48px;
                font-size: 48px;
                font-family: fangzheng;
                font-weight: 100;
                margin-top: 18px;
            }
            .line{
                margin: 42px 0 56px;
                width: 36px;
                height: 6px;
                line-height: 6px;
                background: #fe4166;
            }
        }
        .des{
            font-size: 24px;
            color: #333;
            letter-spacing: 1px;
            line-height: 1.9;
        }
    }
    .company{
        margin-top: 158px;
    }
    .experience{
        .des{
            padding-left: 82px;
            .timeLine{
                margin-top: 60px;
                line-height: 27px;
                background: url(../assets/images/ic_xiaotubiao.png)top left no-repeat;
                text-indent: 70px;
                &.Line86{
                    margin-top: 96px;
                }
                p{
                    font-family: fzlt;
                    font-size: 24px;
                    color: #333;
                }
                &.experienceLine{
                    margin-top: 56px;
                }
                .desImg{
                    margin: 84px 0 0 90px;
                    box-shadow: 12px 12px #e83d63;
                }
            }
        }
    }
    .brand{
        margin-bottom: 120px;
        .products{
            .title{
                display: inline-block;
                background: #fe4166;
                border-radius: 6px;
                line-height: 38px;
                padding: 0 10px;
                color: #fff;
                font-size: 24px;
                font-weight: bolder;
            }
            .contentBox{
                margin-top: 46px;
            }
            .itemDes{
                width: 1040px;
                margin: 0 auto;
                display: flex;
                justify-content: space-around
            }
            .itemLabel{
                box-sizing: border-box;
                width: 445px;
                padding-left: 63px;
                margin: 30px auto;
                display: flex;
                .labelImg{
                    width: 27px;
                    height: 26px;
                    background: url(../assets/images/ic_xiaotubiao.png) top left no-repeat;
                }
                .label{
                    margin-left: 28px;
                    line-height: 26px;
                    font-size: 24px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/groupIntroduction.vue